/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     用户数据管理
  +--------------------------------------------------------------------------------------
*/

import { loginByMobileApi, logoutApi } from "@/api/common/loginApi";
import { getMeApi, editorMeApi } from "@/api/common/meApi";

import {
  getAccessToken,
  setAccessToken,
  removeAccessToken,
} from "@/utils/cookie";

/**
 * logoutClean: 退出程序时清理工作
 */
function logoutClean (commit) {
  // commit("SET_PERMISSIONS", []);
  removeAccessToken();
}

const userStore = {
  state: {
    accessToken: getAccessToken(),
    taskInProcess: 0,
    taskToDownload: 0,
    user: {}
  },

  mutations: {
    SET_ACCESS_TOKEN: (state, accessToken) => {
      state.accessToken = accessToken;
    },

    SET_USER: (state, user) => {
      state.user = Object.assign({}, user)
    },

    SET_TASK_STAT: (state, obj) => {
      state.taskInProcess = obj.in_process || 0;
      state.taskToDownload = obj.to_download || 0;
    }
  },
  actions: {
    // 用户名登录
    loginByMobileAction ({ commit }, formData) {
      return new Promise((resolve, reject) => {
        loginByMobileApi(formData)
          .then(res => {
            if (!res.errno) {
              let tmp = res.data.access_token
              commit("SET_ACCESS_TOKEN", tmp);
              setAccessToken(tmp);
              resolve(res);
            } else {
              resolve(res)
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    loginByQRAction ({ commit }, formdata) {
      return new Promise((resolve, reject) => {
        commit("SET_ACCESS_TOKEN", formdata.data.access_token);
        setAccessToken(formdata.data.access_token);
        resolve(formdata);
      });
    },

    // 获取用户信息(含客户信息)
    getUserInfoAction ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getMeApi()
          .then(res => {
            if (!res.errno) {
              commit("SET_USER", res.data.user);
              commit("SET_GOD", res.data.god);
              commit("SET_GOD_SETTING", res.data.god_setting);
              resolve(res);
            } else {
              reject(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    // 设置用户信息
    setUserInfoAction ({ commit, state }, formData) {
      return new Promise((resolve, reject) => {
        editorMeApi(formData)
          .then(r => {
            if (!r.errno) {
              getMeApi().then(res => {
                if (!res.errno) {
                  commit("SET_USER", res.data.user);
                  commit("SET_GOD", res.data.god);
                  resolve(res);
                } else {
                  reject(res);
                }
              });
            } else {
              reject(r);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    // 登出
    logOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logoutApi()
          .then(res => {
            logoutClean(commit);
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    // 前端登出
    fedLogOut ({ commit }) {
      return new Promise(resolve => {
        logoutClean(commit);
        resolve();
      });
    }
  }
};

export default userStore;
